import React from "react";
import styled from "styled-components";

const Button = styled.button`
  background: linear-gradient(90deg, #f4b60b, #b6510c);
  color: var(--white);
  column-gap: 6px;
  font-size: 16px;
  border: 1px solid #b6510c;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 0px;
  height: 34px;
  width: ${(props) => props.width};
  transition: 0.4s;

  &:hover {
    background: var(--white);
    color: var(--choco);
  }
`;

const CustomButton = ({
  className,
  title,
  onClick,
  icon,
  disabled,
  width = "260px",
  preIcon,
  tooltip,
}) => {
  return (
    <Button
      className={className}
      onClick={onClick}
      width={width}
      disabled={disabled}
      title={tooltip ? tooltip : title}
    >
      {preIcon && (
        <span
          style={{
            marginRight: "5px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {preIcon}
        </span>
      )}{" "}
      {title} {icon}
    </Button>
  );
};

export default CustomButton;
